import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/app.materials';
import {CompanyModel} from "../../../../../../shared/models/company.model";
import {UtilService} from "../../../../../../shared/services/util.service";

@Component({
  selector: 'app-new-portfolio-active-sorting',
  templateUrl: './new-portfolio-active-sorting.component.html',
  styleUrls: ['./new-portfolio-active-sorting.component.scss'],
  standalone: true,
  imports: [CommonModule, MaterialModule]
})
export class NewPortfolioActiveSortingComponent implements OnInit {

  @Input() selected: CompanyModel[];
  @Input() selectedFilterLabels: any;
  @Input() filter_label_length_limit: number;
  @Input() currentFilters: any;
  @Input() sorting: any;
  @Input() checked: boolean = false;

  @Input() onCheckChange = new EventEmitter<any>();

  @Output() deleteSortClick = new EventEmitter<any>();
  @Output() deleteDynamicFilterClick = new EventEmitter<any>();
  @Output() deleteFilterClick = new EventEmitter<any>();
  @Output() selectAllClick = new EventEmitter<any>();


  constructor(private util: UtilService) {
  }

  ngOnInit(): void {
  }

  sortingNiceName(key) {
    return this.util.sortingNiceName(key);
  }

  onToggle() {
    this.onCheckChange.emit({});
  }

  openFilter(s) {
    (document.getElementsByClassName(s.value[0].label_raw)[0].children[0] as any).click();
  }
  
  interval = null;
  moveRight() {
    const table = document.querySelector('.outer-table-container');
    if (!table) {
      console.warn('Asset table container not found');
      return;
    }
    
    // Clear any existing interval
    this.clearInterval();
    
    this.interval = setInterval(() => {
      const maxScroll = table.scrollWidth - table.clientWidth;
      if (table.scrollLeft < maxScroll) {
        table.scrollLeft += 30;
      } else {
        this.clearInterval();
      }
    }, 50);
  }

  moveLeft() {
    const table = document.querySelector('.outer-table-container');
    if (!table) {
      console.warn('Asset table container not found');
      return;
    }
    
    // Clear any existing interval
    this.clearInterval();
    
    this.interval = setInterval(() => {
      if (table.scrollLeft > 0) {
        table.scrollLeft -= 30;
      } else {
        this.clearInterval();
      }
    }, 50);
  }

  clearInterval() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

}
